import { useContext } from 'react';

import { AttachmentsConfigContext } from './AttachmentsConfigContext';

export const useAttachmentsConfig = () => {
    return useContext(AttachmentsConfigContext);
};
